import React from "react";
import { TextInput } from "react-native";
import { SHr, SPage, SText, STheme, SView } from "servisofts-component2";
import MDL from "../MDL";

type TestState = {
    loading: boolean,
    posting: boolean,
    putting: boolean,
    error: string | null,
    preguntas: any,
    jsonInputPost: string,
    jsonInputPut: string,
    postResponse: any,
    putResponse: any,
}

export default class Test3 extends React.Component<any, TestState> {

    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            posting: false,
            putting: false,
            error: null,
            preguntas: null,
            postResponse: null,
            putResponse: null,
            jsonInputPost: JSON.stringify({
                id: "7",
                state: 1,
                matricula: "7",
                dni: "7",
            }, null, 2),
            jsonInputPut: JSON.stringify({
                id: "1",
                state: 1,
                matricula: "2200001",
                dni: "2200001",
            }, null, 2),
        };
    }

    async componentDidMount() {
        try {
            const preguntas = await MDL.checklist.getChecklistDetalle();
            this.setState({ preguntas, loading: false });
        } catch (error: any) {
            this.setState({
                loading: false,
                error: error?.message || String(error)
            });
        }
    }

    onPostDetalle = async () => {
        this.setState({ posting: true, error: null, postResponse: null });
        try {
            const body = JSON.parse(this.state.jsonInputPost || "{}");
            const postResponse = await MDL.checklist.postChecklistDetalle(body);
            this.setState({ postResponse, posting: false });
        } catch (error: any) {
            this.setState({
                posting: false,
                error: error?.message || String(error)
            });
        }
    }

    onPutDetalle = async () => {
        this.setState({ putting: true, error: null, putResponse: null });
        try {
            const body = JSON.parse(this.state.jsonInputPut || "{}");
            const putResponse = await MDL.checklist.putChecklistDetalleUpdate(body);
            this.setState({ putResponse, putting: false });
        } catch (error: any) {
            this.setState({
                putting: false,
                error: error?.message || String(error)
            });
        }
    }

    render() {
        const { loading, posting, putting, error, preguntas, jsonInputPost, jsonInputPut, postResponse, putResponse } = this.state;
        return <SPage title={"testing"} disableScroll center>
            <SView col="xs-11 sm-10 md-8 lg-6" padding={16}>
                <SText fontSize={16} bold>Checklist Detalle Test</SText>
                <SHr height={8} />
                {loading ? <SText>Cargando...</SText> : null}
                {error ? <SText color={STheme.color.danger}>{error}</SText> : null}
                {!loading && !error ? (
                    <SText fontSize={12}>
                        {JSON.stringify(preguntas, null, 2)}
                    </SText>
                ) : null}

                <SHr height={24} />
                <SText fontSize={14} bold>PARTE 1</SText>
                <SHr height={8} />
                <SText fontSize={14} bold>POST /checklist/checklist_detalle</SText>
                <SHr height={8} />
                <TextInput
                    multiline
                    numberOfLines={10}
                    value={jsonInputPost}
                    onChangeText={(text) => this.setState({ jsonInputPost: text })}
                    placeholder='Pega aqui el JSON...'
                    placeholderTextColor={STheme.color.lightGray}
                    style={{
                        width: "100%",
                        minHeight: 180,
                        borderWidth: 1,
                        borderColor: STheme.color.lightGray,
                        borderRadius: 8,
                        padding: 10,
                        color: STheme.color.text,
                        textAlignVertical: "top",
                        backgroundColor: STheme.color.background,
                    }}
                />
                <SHr height={10} />
                <SView
                    center
                    onPress={() => {
                        if (posting) return;
                        this.onPostDetalle();
                    }}
                    style={{
                        width: "100%",
                        maxWidth: 360,
                        height: 48,
                        borderRadius: 10,
                        backgroundColor: posting ? STheme.color.lightGray : STheme.color.secondary,
                    }}
                >
                    <SText bold color={STheme.color.primary}>
                        {posting ? "Enviando..." : "Registrar Detalle (POST)"}
                    </SText>
                </SView>
                {postResponse ? (
                    <>
                        <SHr height={10} />
                        <SText fontSize={12}>{JSON.stringify(postResponse, null, 2)}</SText>
                    </>
                ) : null}

                <SHr height={24} />
                <SText fontSize={14} bold>PARTE 2</SText>
                <SHr height={8} />
                <SText fontSize={14} bold>PUT /checklist/checklist_detalle/update</SText>
                <SHr height={8} />
                <TextInput
                    multiline
                    numberOfLines={10}
                    value={jsonInputPut}
                    onChangeText={(text) => this.setState({ jsonInputPut: text })}
                    placeholder='Pega aqui el JSON para update...'
                    placeholderTextColor={STheme.color.lightGray}
                    style={{
                        width: "100%",
                        minHeight: 180,
                        borderWidth: 1,
                        borderColor: STheme.color.lightGray,
                        borderRadius: 8,
                        padding: 10,
                        color: STheme.color.text,
                        textAlignVertical: "top",
                        backgroundColor: STheme.color.background,
                    }}
                />
                <SHr height={10} />
                <SView col="xs-12" row center>
                    <SView
                        col="xs-6"
                        center
                        onPress={() => {
                            if (putting) return;
                            this.onPutDetalle();
                        }}
                        style={{
                            height: 48,
                            borderRadius: 10,
                            backgroundColor: putting ? STheme.color.lightGray : STheme.color.info,
                        }}
                    >
                        <SText bold color={STheme.color.white}>
                            {putting ? "Actualizando..." : "Actualizar Detalle (PUT)"}
                        </SText>
                    </SView>
                </SView>
                {putResponse ? (
                    <>
                        <SHr height={10} />
                        <SText fontSize={12}>{JSON.stringify(putResponse, null, 2)}</SText>
                    </>
                ) : null}
            </SView>
        </SPage >
    }
}